import React from 'react';
import { CMS_LOCATION } from '../../constants/constants';

export const ContactUsBanner = ({HeaderText1, HeaderText2, ImageName}) => {
    // const loadPath = require.context('../../assets/resources/images', true);
    // const Image = loadPath(ImageName);
    let backgroundStyle = {
        "background": "url(" + CMS_LOCATION + ImageName + ") no-repeat"
    }
    return (
        <div className="row">
            <div className="columns medium-12 padding-all-zero">
                    <div className="w_contact-banner">
                        <div className="contactus_image" style={backgroundStyle} alt={HeaderText1}>
                            <h1 className="title">
                            {HeaderText1}</h1>
                            <h4 className="description">
                            {HeaderText2} </h4>
                        </div>
                    </div>
            </div>
        </div>  
    )
}



// WEBPACK FOOTER //
// ./src/components/modules/ContactUsBanner.js